import React, { useState } from "react";

import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import axios from "axios";
import cx from "classnames";
import buildUrl from "build-url";

import { Button, Form, Header, Image } from "semantic-ui-react";

import AuthService from "../../../services/auth.service";

import styles from "./signin.module.scss";

export default function SigninView(props) {
  const { path } = useRouteMatch();

  return (
    <div className={cx(styles.content)}>
      <div className={cx(styles.left)}>
        <div className={cx(styles.inner)}>
          <Image src="/images/logo.png" className={cx(styles.logo)} />
          <h1 className={cx(styles.heading)}>Paperflite Admin</h1>
        </div>
      </div>
      <div className={cx(styles.right)}>
        <Switch>
          <Route path={`${path}`} exact>
            <SignInForm />
          </Route>
        </Switch>
      </div>
    </div>
  );
}

function SignInForm(props) {
  const history = useHistory();
  const [fetchingToken, setFetchingToken] = useState(false);

  function handleAuthenticate() {
    //Calculate Position
    var dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : 400;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : 400;

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : 1280;
    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : 800;

    var w = 0.8 * width;
    var h = 0.8 * height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;

    const url = buildUrl(process.env.REACT_APP_API_URL_V2, {
      path: `/admin/auth/3.0/login`,
    });

    var newWindow = window.open(
      url,
      `Authorize Cognito User Account`,
      "scrollbars=yes, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left
    );

    // Puts focus on the newWindow
    if (newWindow.focus) {
      newWindow.focus();
    }

    //Attaching message event listner
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent, handleAuthenticateEvent, false);
    return false;
  }

  async function handleAuthenticateEvent(e) {
    //Removing message event listner
    var detachEventMethod = window.removeEventListener
      ? "removeEventListener"
      : "detachEvent";
    var deEventer = window[detachEventMethod];
    var messageEvent =
      detachEventMethod === "detachEvent" ? "onmessage" : "message";
    if (e.data.type === "COGNITO_AUTHORIZATION_SUCCESS") {
      setFetchingToken(true);
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;

      if (!error && !fetchingToken) {
        await axios
          .get(process.env.REACT_APP_API_URL_V2 + "/admin/auth/3.0/oauth/token", {
            params: { code, state },
          })
          .then((response) => {
            if (response.status === 200) {
              var data = response.data;
              AuthService.saveToken(data.access_token, data.refresh_token);
              history.push("/");
            }
          })
          .catch((error) => {
            history.push(`/login?error/${error.message}`);
          });
      }

      setFetchingToken(false);
      deEventer(messageEvent, handleAuthenticateEvent, false);
    }
  }

  return (
    <div className={cx(styles.form, styles.login)}>
      <Header as="h2" className={cx(styles.header)}>
        Sign in to unleash the power of admin application!
      </Header>
      <Form className={cx(styles.btnAwsLogin)} onSubmit={handleAuthenticate}>
        <Button primary type="submit">
          Sign in with AWS Cognito
        </Button>
      </Form>
    </div>
  );
}
